export default __webpack_public_path__ + "assets/fd9cce.svg";